'use client'

import React from 'react'
import {useTranslations} from 'next-intl'
import {FullScreen, useFullScreenHandle} from 'react-full-screen'
import {isMobile} from 'react-device-detect'
import {css, useTheme} from '@emotion/react'
import {Typography} from '@mui/material'

import GenericPanel from '../../../../components/layouts/TwoPanelLayout/GenericPanel'
import Paper from '../../../../components/elements/Paper'


export default function ScreenTester() {
  const theme = useTheme()
  const styles = {
    root: css`
      margin: 0 auto;
      max-width: 800px;
    `,

    content: css`
      padding: 32px;
      background: ${theme.palette.surface.main};
    `,

    section: css`
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 16px;

      margin-top: 16px;

      & > div {
        flex: 1;
        max-width: 150px;
        height: 60px;
        position: relative;

        div {
          width: 100%;
          height: 100%;
        }

        &.fullscreen-enabled div {
          display: none;
        }
      }
    `,

    black: css`
      &.fullscreen-enabled {
        background: black;
      }

      div {
        background: black;
      }
    `,

    white: css`
      &.fullscreen-enabled {
        background: white;
      }

      div {
        background: white;
      }
    `,

    red: css`
      &.fullscreen-enabled {
        background: #ff0000;
      }

      div {
        background: #ff0000;
      }
    `,

    green: css`
      &.fullscreen-enabled {
        background: #00ff00;
      }

      div {
        background: #00ff00;
      }
    `,

    blue: css`
      &.fullscreen-enabled {
        background: #0000ff;
      }

      div {
        background: #0000ff;
      }
    `,

    yellow: css`
      &.fullscreen-enabled {
        background: #ffff00;
      }

      div {
        background: #ffff00;
      }
    `,

    cyan: css`
      &.fullscreen-enabled {
        background: #00ffff;
      }

      div {
        background: #00ffff;
      }
    `,

    magenta: css`
      &.fullscreen-enabled {
        background: #ff00ff;
      }

      div {
        background: #ff00ff;
      }
    `,
  }

  const t = useTranslations()

  const blackHandle = useFullScreenHandle()
  const whiteHandle = useFullScreenHandle()
  const redHandle = useFullScreenHandle()
  const greenHandle = useFullScreenHandle()
  const blueHandle = useFullScreenHandle()
  const yellowHandle = useFullScreenHandle()
  const cyanHandle = useFullScreenHandle()
  const magentaHandle = useFullScreenHandle()

  return (
    <GenericPanel
      css={styles.root}
      top={t('screen-tester.input-description')}
      content={(
        <Paper css={styles.content}>
          {!isMobile && (
            <>
              <header css={styles.header}>
                <Typography>{t('screen-tester.select-hint')}</Typography>
              </header>
              <section css={styles.section}>
                <FullScreen css={styles.black} handle={blackHandle}>
                  <Paper onClick={blackHandle.enter}/>
                </FullScreen>

                <FullScreen css={styles.white} handle={whiteHandle}>
                  <Paper onClick={whiteHandle.enter}/>
                </FullScreen>
              </section>
              <section css={styles.section}>
                <FullScreen css={styles.red} handle={redHandle}>
                  <Paper onClick={redHandle.enter}/>
                </FullScreen>
                <FullScreen css={styles.green} handle={greenHandle}>
                  <Paper onClick={greenHandle.enter}/>
                </FullScreen>
                <FullScreen css={styles.blue} handle={blueHandle}>
                  <Paper onClick={blueHandle.enter}/>
                </FullScreen>
              </section>
              <section css={styles.section}>
                <FullScreen css={styles.yellow} handle={yellowHandle}>
                  <Paper onClick={yellowHandle.enter}/>
                </FullScreen>
                <FullScreen css={styles.cyan} handle={cyanHandle}>
                  <Paper onClick={cyanHandle.enter}/>
                </FullScreen>
                <FullScreen css={styles.magenta} handle={magentaHandle}>
                  <Paper onClick={magentaHandle.enter}/>
                </FullScreen>
              </section>
            </>
          )}
          {isMobile && (
            <div>{t('warning-device-not-supported')}</div>
          )}
        </Paper>
      )}
    />
  )
}

